import { ITutorialJourneyProfileDto } from "@growth-machine-llc/stridist-api-client";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import TutorialJourneyProfilesService from "../../../services/TutorialJourneyProfilesService";
import { TUTORIAL_PROFILES_QUERY_KEY } from "../journey/TutorialJourneysList";

export function useDeleteTutorialJourneyProfile() {
  return useOptimisticUpdateMutation({
    queryKey: [TUTORIAL_PROFILES_QUERY_KEY],
    mutationFn: TutorialJourneyProfilesService.deleteTutorialJourneyProfile,
    optimisticUpdater: {
      updateFn: (
        oldData: { profiles: ITutorialJourneyProfileDto[] },
        id: number,
      ) => ({
        ...oldData,
        profiles: oldData.profiles.filter(
          (journeyProfile) => journeyProfile.id !== id,
        ),
      }),
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
  });
}
